/**
 * Attachment size limits for outgoing mail.
 *
 * Isomorphic on purpose: the compose dialog blocks Send past the limit **and** the
 * endpoint rejects past the same limit. Two numbers would drift, and the failure mode
 * of drift is the worst kind — the dialog says a message is fine, the request is
 * refused, and the user is told nothing useful.
 *
 * `MAX_TOTAL_ATTACHMENT_BYTES` covers the generated PDF *plus* everything the user
 * added, because that is what the request actually carries. 10 MB of raw attachments
 * becomes ~13.6 MB once MIME base64-encodes them, which still clears the 25 MB most
 * providers accept, while `MAX_FILE_BYTES` keeps any single file inside multer's
 * per-file limit.
 */

export const MAX_FILE_BYTES = 10 * 1024 * 1024;
export const MAX_TOTAL_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const MAX_ATTACHMENT_COUNT = 10;

export const formatBytes = (bytes: number): string => {
    if (!bytes) return '0 KB';
    const mb = bytes / (1024 * 1024);
    if (mb >= 1) return `${mb.toFixed(1)} MB`;
    return `${Math.max(1, Math.round(bytes / 1024))} KB`;
};
